import styled from 'styled-components';

const BotoesAcao = styled.div`
  margin-top: var(--espacamento-m);
`;

export default BotoesAcao;
